module.exports = __webpack_public_path__ + "img/circle.c7684f00.png";